module.exports = __webpack_public_path__ + "img/UI_common_framelabelPX_02_c09c4b182.png";